import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberUtils from '../../../utils/NumberUtils';
import StringConstant from '../../../constants/StringConstants';

class CustomComponentArchive extends Component {
  constructor(props) {
    super(props);

    this.cellClick = this.cellClick.bind(this);

    this.state = {
      show: false,
      custGrid: false,
    };
  }

  cellClick() {
    this.props.customClick(this.props.rowData);
  }

  render() {
    switch (this.props.metadata.columnName) {
      case 'toAccountName':
        return (
          <div className="custom-column" onClick={this.cellClick}>
            {this.props.rowData.toAccountName},<br />
            {this.props.rowData.reference}
          </div>
        );
      case StringConstant.mpAmount:
        if (
          this.props.rowData.amount === undefined ||
          this.props.rowData.amount === null
        ) {
          return (
            <div className="custom-column" onClick={this.cellClick}>
              -
            </div>
          );
        } else {
          return (
            <div className="custom-column" onClick={this.cellClick}>
              {NumberUtils.decimalFormat(this.props.rowData.amount, 3, true)}
            </div>
          );
        }
      case StringConstant.Type:
        return (
          <div className="custom-column" onClick={this.cellClick}>
            {this.props.data}
          </div>
        );
      case 'option':
        return (
          <a href="javascript:void(0)" onClick={this.cellClick}>
            View
          </a>
        );
      default:
        return (
          <div className="custom-column" onClick={this.cellClick}>
            {this.props.data}
          </div>
        );
    }
  }
}

CustomComponentArchive.propTypes = {
  rowData: PropTypes.object,
  content: PropTypes.object,
  metadata: PropTypes.object,
  data: PropTypes.string || PropTypes.number,
  customClick: PropTypes.func,
};

export { CustomComponentArchive };
